export const GRAPHME_URI = `https://graph.microsoft.com/v1.0/me/photo/$value`;
export const ACCESSREQUEST_URL =
  "https://maestro.insights.maersk.com/ie/admin/accessRequests";

// export const DATABOOK_API = "https://databook-api-preprod.maersk-digital.net/databook";
// export const DATABOOK_API = "https://databook-api-preprod.maersk-digital.net/databook";

export const DATABOOK_API = (process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_RUN_ENV === "development")
  ? "https://databook-api-dev.maersk-digital.net/databook"
  : (process.env.NODE_ENV === "development" &&
    process.env.REACT_APP_RUN_ENV === "preprod")
    ? "https://databook-api-preprod.maersk-digital.net/databook"
    : "https://databook-api-prod.maestro.maersk.com/databook";
// export const TELEMETRY_API = "https://telemetry-api-preprod.maersk-digital.net/databook/";
export const TELEMETRY_API = (process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_RUN_ENV === "development")
  ? "https://telemetry-api-dev.maersk-digital.net/databook/"
  : (process.env.NODE_ENV === "development" &&
    process.env.REACT_APP_RUN_ENV === "preprod")
    ? "https://telemetry-api-preprod.maersk-digital.net/databook/"
    : "https://telemetry-api-prod.maestro.maersk.com/databook/";

export const MARTBUILDER_API = (process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_RUN_ENV === "development")
  ? "https://datamart-api-dev.maestro.maersk.com"
  : (process.env.NODE_ENV === "development" &&
    process.env.REACT_APP_RUN_ENV === "preprod")
    ? "https://datamart-api-preprod.maersk-digital.net"
    : "https://datamart-api-prod.maersk-digital.net";

export const PRODUCT_REG_API = (process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_RUN_ENV === "development")
  ? "https://maestro-productregistrationbackend.westeurope.dev.maersk.io"
  : (process.env.NODE_ENV === "development" &&
    process.env.REACT_APP_RUN_ENV === "preprod")
    ? "https://maestro-productregistrationbackend.westeurope.prod.maersk.io"
    : "https://maestro-productregistrationbackend.westeurope.prod.maersk.io";

// export const PRODUCT_REG_API = "https://maestro-productregistrationbackend.westeurope.dev.maersk.io";

export const DATABOOK_GPT_URL = `https://chat-api.maestro.maersk.com/`;
export const YAMMER_URL = "https://web.yammer.com/main/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiIxNTAyMzkzNzk0NTYifQ/all";


